<template>
  <div class="SEARCHMAIN">
    <div class="bgs">
      <img src="@/assets/bgs.svg" />
    </div>
    <div class="mains">
      <!-- 标题 -->
      <!-- <div class="manageTop"></div> -->
      <div class="titles">
        <img src="@/assets/logo1.svg" />
      </div>
      <!-- <div class="midbar"></div> -->
      <!-- 搜索框 -->
      <div class="searchInputs">
        <div class="goBack" @click="returnHome()">
          <img class="goBackIcon" src="@/assets/home.svg" />
          <div class="goBackBox">首页</div>
        </div>
        <div class="split"></div>
        <div class="search" v-show="showSearchTop">
          <input
            type="text"
            class="searchCTE"
            placeholder="输入要办事项的关键字"
            v-model="searchContent"
          />
          <img
            class="searchDel"
            @click="searchContent = ''"
            src="@/assets/delete.svg"
          />
          <div class="searchBTN" @click="search()">
            <img src="@/assets/searchs.svg" />
            <div>搜索</div>
          </div>
        </div>
      </div>
      <!-- 搜索出来的内容 -->
      <div class="contents">
        <!-- 提示信息 -->
        <div
          class="keyword"
          v-show="showSearchTop && searchContent != '' && !mainflag"
        >
          您搜索的关键词是：<span>{{ searchContent }}</span
          >，搜索结果如下：
        </div>
        <div class="showList" v-show="!mainflag">
          <div class="contentLIST">
            <div class="contentListCP conteneTitle">事项名称</div>
            <div class="contentListCP conteneTitle">事项类型</div>
            <div class="contentListCP conteneTitle">面向对象</div>
          </div>
          <!-- 循环的内容 -->
          <div
            class="contentLIST"
            :key="item"
            v-for="item in list"
            @click="enterDetail(item.BusinessObject, item.BusinessID)"
          >
            <div class="contentListCP textLeft">
              {{ item.BusinessName }}
            </div>
            <div class="contentListCP textLeft">
              {{ item.ClassName }}-{{ item.SubClassName }}
            </div>
            <div class="contentListCP textLeft">{{ item.ObjectName }}</div>
          </div>
        </div>
        <!-- 分页 -->
        <div class="page">
          <div class="">
            <el-pagination
              layout="prev, pager, next"
              :total="totalItem"
              :page-size="10"
              :pager-count="5"
              :hide-on-single-page="true"
              @current-change="currentPage"
              class="elpage"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom" :style="elementStyle">
      版权所有 © 2021 河南大学教务处
    </div>
  </div>
</template>



<style scoped>
.SEARCHMAIN {
  width: 100%;
  height: 100%;
  background: #f6f9ff;
  border-radius: 0px 0px 0px 0px;
  align-items: center;
}

.bgs {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: auto;
}
.bgs img {
  width: 100%;
  height: auto;
}

.mains {
  width: 1920px;
  height: 1080px;
  /* position: relative; */
}

.titles {
  position: absolute;
  left: 20%;
  top: 35px;
  width: 489px;
  height: 50px;
}

.searchInputs {
  background: #ffffff;
  position: absolute;
  display: flex;
  align-items: center;
  left: 20%;
  top: 120px;
  width: 60%;
  height: 72px;
  border-radius: 8px 8px 8px 8px;
}

.searchInputs .goBack {
  width: 80px;
  height: 33px;
  margin-left: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.goBack .goBackBox {
  margin-left: 8px;
  width: 44px;
  height: 33px;
  font-weight: 500;
  font-size: 22px;
  color: #00589f;
  line-height: 33px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.goBack:hover {
  cursor: pointer;
}

.searchInputs .split {
  margin: 12px 0 12px 33px;
  width: 2px;
  height: 48px;
  background: #9fbfdf;
  border-radius: 4px 4px 4px 4px;
}

.search {
  flex: 1;
  color: white;
  margin-left: 40px;
  display: flex;
  align-items: center;
}

.search .searchCTE {
  font-weight: 400;
  font-size: 24px;
  color: #000000;
  line-height: 36px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  border: none;
  outline: none;
}

.search .searchDel {
  margin-left: auto;
  margin-right: 5px;
}

.searchBTN {
  float: right;
  width: 160px;
  height: 56px;
  background: #00589f;
  margin: 10px;
  border-radius: 4px 4px 4px 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.searchBTN img {
  width: 24px;
  height: 24px;
}

.searchBTN div {
  margin-left: 8px;
  width: 48px;
  height: 36px;
  font-weight: 400;
  font-size: 24px;
  color: #ffffff;
  line-height: 36px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.searchBTN:hover {
  cursor: pointer;
}

/* 清除浮动文档流问题 */
.search::after {
  content: "";
  display: block;
  clear: both;
}

.contents {
  position: absolute;
  top: 200px;
  left: 20%;
  width: 60%;
  height: 780px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
}

.keyword {
  margin-left: 2.85%;
  margin-top: 2.56%;
  width: auto;
  height: 27px;
  font-weight: 600;
  font-size: 18px;
  color: #000000;
  line-height: 27px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.keyword span {
  color: #00589f;
}

.showList {
  margin-left: 2.85%;
  margin-right: 2.85%;
  margin-top: 2.04%;
}

.contentLIST {
  display: flex;
  align-items: center;
  height: 50px;
  line-height: 50px;
  text-align: left;
  margin: auto;
}

.contentLIST:nth-child(odd) {
  background: #f3f8fd;
}

.contentLIST:hover {
  cursor: pointer;
}

.conteneTitle {
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  line-height: 48px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.contentLIST .contentListCP:first-child,
.contentLIST .contentListCP:nth-child(2) {
  margin-left: 2.83%;
  width: 40%;
  height: 100%;
  float: left;
}

.contentLIST .contentListCP:nth-child(3) {
  margin-left: 2.83%;
  flex-grow: 1;
  /* 第三个元素宽度自适应 */
  height: 100%;
  float: left;
}

.textLeft {
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 48px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.page {
  position: absolute;
  bottom: 10px;
  width: 100%;
  height: 20px;
  margin: auto;
  padding-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.elpage {
  width: 400px;
  height: 50px;
}
.bottom {
  position: absolute;
  left: 856px;
  width: 209px;
  height: 21px;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 21px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
</style>

<script>
import axios from "axios";
export default {
  name: "pc_search",
  mounted: function () {
    console.log(this.$route.params.msg);
    this.searchContent = this.$route.params.msg;
    this.search();
    //显示搜素框
    this.showSearchTop = true;
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateElementPosition); // 清理事件监听器
  },
  data: function () {
    return {
      //搜索详情页是否展示搜索框 true为展示
      showSearchTop: false,
      //显示附件
      showAppend: false,
      //显示表格
      showChart: false,
      //显示保存附件表格的大盒子
      showAppendBox: true,
      searchContent: "",
      pageNum: 1,
      totalItem: 33,
      list: [
        // {
        //   BusinessClass: 1,
        //   BusinessDepartment: "标题标题标题标题标题标题标题标题标题",
        //   BusinessID: 1001,
        //   BusinessName: "关于开学军训的通知",
        //   BusinessObject: "10",
        //   ClassID: "10",
        //   ClassName: "开学教育21",
        //   Department: "15",
        //   ObjectName: "学生",
        //   SubClassName: "军训",
        // },
      ],
      //true详情页展示
      mainflag: false,
      //点击文章后展示的详细信息
      detailMSG: [
        {
          // ContactPhone: "10000000",
          // BusinessContent: "11月15日下午，……(还有信息，不在文档里展示了) ",
          // BusinessName: "关于开学军训的通知",
          // SubClassName: "军训",
          // BusinessClass: "1001",
          // ClassName: "开学教育",
          // BusinessDepartment: "10",
          // ClassId: "10",
          // BusinessObject: "10",
          // BusinessID: 1001,
          // DepartName: "教务处",
        },
      ],
      //类型一的附件 相关制度ID
      attachment1: [
        // {
        //   AttachmentFileName: "12",   //id
        //   AttachmentID: 1,
        //   AttachmentName: "测试数据", //展示名称
        //   AttachmentType: "1",
        //   BusinessID: "1",
        // },
      ],
      //类型二的附件  相关表格ID
      attachment2: [],
      elementStyle: {
        position: "absolute",
        width: "100%",
        left: "0px",
        height: "21px",
        fontWeight: 400,
        fontSize: "14px",
        color: "#666666",
        lineHeight: "21px",
        textAlign: "center",
        fontStyle: "normal",
        textTransform: "none",
        top: "1027px",
        bottom: "",
      },
    };
  },
  methods: {
    updateElementPosition() {
      if (window.innerHeight > 1080) {
        this.elementStyle.bottom = "32px";
        this.elementStyle.top = ""; // 清空 top 样式
      } else {
        this.elementStyle.top = "1027px";
        this.elementStyle.bottom = ""; // 清空 bottom 样式
      }
    },
    aha: function () {
      console.log("测试");
    },
    returnPage: function () {
      this.mainflag = false;
      //显示搜索框
      this.showSearchTop = true;
    },
    search: function () {
      console.log("点击搜索", this.searchContent);
      if (!this.searchContent) {
        alert("请输入正确的关键字");
      } else {
        // 一些初始化操作
        this.attachment1 = [];
        this.attachment2 = [];
        this.mainflag = false;
        axios({
          methods: "get",
          url:
            "https://jwgf.henu.edu.cn:443/seacher/queryAll/" +
            this.searchContent +
            "/" +
            this.pageNum,
        }).then((res) => {
          console.log(res.data);
          let resTotal = res.data[res.data.length - 1];
          console.log("总数据数", resTotal.sum);
          this.totalItem = resTotal.sum;
          res.data.pop();
          console.log(res.data);
          this.list = res.data;
        });
      }
    },
    enterDetail: function (role, id) {
      console.log("面向对象", role, "文章id", id);
      this.$router.replace({
        path: "./pc_detail",
        name: "pc_detail",
        params: {
          role: role,
          articleID: id,
          searchCTN: this.searchContent,
        },
      });
      //隐藏搜索框
      // this.showSearchTop = false;
      //控制某个盒子显示与否的标志
      // this.mainflag = true;

      // this.changepage(id);
      // axios({
      //   methods: "get",
      //   url: "https://jwgf.henu.edu.cn:443/seacher/queryOneBusinessWithId/" + id,
      // }).then((res) => {
      //   console.log(res.data);
      //   this.detailMSG = res.data;
      // });
    },
    currentPage(index) {
      console.log(index);
      this.pageNum = index;
      axios({
        methods: "get",
        url:
          "https://jwgf.henu.edu.cn:443/seacher/queryAll/" +
          this.searchContent +
          "/" +
          this.pageNum,
      }).then((res) => {
        console.log(res.data);
        let resTotal = res.data[res.data.length - 1];
        console.log("总数据数", resTotal.sum);
        this.totalItem = resTotal.sum;
        res.data.pop();
        console.log(res.data);
        this.list = res.data;
      });
    },
    // changepage: function (articleID) {
    //   console.log("点击了文章");
    //   if (this.mainflag) {
    //     this.mainflag = !this.mainflag;
    //   }
    //   axios({
    //     methods: "get",
    //     url:
    //       "https://jwgf.henu.edu.cn:443/seacher/queryOneBusinessWithId/" + articleID,
    //   }).then((res) => {
    //     console.log(res.data);
    //     this.detailMSG = res.data;
    //     this.dealMSG(res.data);
    //   });
    // },
    dealMSG(totalData) {
      console.log("1111111111111111");
      this.attachment1 = [];
      this.attachment2 = [];
      for (let i = 1; i < totalData.length; i++) {
        if (totalData[i].AttachmentType == 0) {
          this.attachment1.push(totalData[i]);
        } else {
          this.attachment2.push(totalData[i]);
        }
      }
      console.log(this.attachment1);
      console.log(this.attachment2);
      if (this.attachment1.length >= 1) {
        this.showAppend = true;
      } else {
        this.showAppend = false;
      }
      if (this.attachment2.length >= 1) {
        this.showChart = true;
      } else {
        this.showChart = false;
      }

      // this.attachment1 = [];
      // this.attachment2 = [];
      if (this.attachment1.length == 0 && this.attachment2.length == 0) {
        this.showAppendBox = false;
      } else {
        this.showAppendBox = true;
      }
    },
    download(name) {
      console.log(name);
      this.theHref = "https://jwgf.henu.edu.cn:443/attachment/download/" + name;
      axios({
        method: "post",
        url: "https://jwgf.henu.edu.cn:443/attachment/download/" + name,
        responseType: "blob",
      }).then((res) => {
        console.log(res.data);
        // this.contentList = res.data;
        this.toDownload(res.data);
      });
    },
    toDownload(data) {
      if (!data) {
        return;
      }

      if (confirm("是否下载此附件")) {
        let url = window.URL.createObjectURL(new Blob([data]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", this.theHref);
        document.body.appendChild(link);
        link.click();
      }
    },
    returnHome() {
      this.$router.push("./pc_home");
    },
  },
};
</script>